module.exports = __webpack_public_path__ + "img/w76.7fde6a6a.svg";